import Typography from "../Typography";

function MapError() {
  return <Typography variant="body2">Error loading map</Typography>;
}

export default MapError;
